/**************************************************************************************************************************************************
*   MODULE NAME     :  SearchActions
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  02-03-2021
*   DESCRIPTION     :  Search API actions
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import * as types from "./actionTypes";
import SearchApi from "../api/SearchApi";

/******* ACTION OBJECTS *******/
export const loadAllAbstractsSuccess = abstractData => {
  return {
    type: types.LOAD_ABSTRACTS_DATA_SUCCESS,
    abstractData
  };
};
export const loadAllAbstractsPaginationsSuccess = abstractData => {
  return {
    type: types.LOAD_ABSTRACTS_PG_DATA_SUCCESS,
    abstractData
  };
};



/*****  ACTION DISPATCHERS  ******/
export const loadAllAbstracts = (payload) => {
  return async dispatch => {
    try {
      const abstractData = await SearchApi.loadAllAbstracts(payload);
      dispatch(loadAllAbstractsSuccess(abstractData));
      return abstractData;
    } catch (error) {
      throw error;
    }
  };
};

export const loadAllAbstractsPagination = (payload,paginationData , colSelected) => {
  return async dispatch => {
    try {
      const abstractData = await SearchApi.loadAllAbstractsPagination(payload , paginationData , colSelected);
      dispatch(loadAllAbstractsPaginationsSuccess(abstractData));
      return abstractData;
    } catch (error) {
      throw error;
    }
  };
};
  export const saveSearch = (saveSearch,searchPayload) => {
  return async () => {
    try {
      return await SearchApi.saveSearch(saveSearch , searchPayload);
    } catch (error) {
      throw error;
    }
  };
 };

 export const loadAllSavedSearch = () => {
  return async () => {
    try {
      return await SearchApi.loadAllSavedSearch();
    } catch (error) {
      throw error;
    }
  };
 };

 export const inactiveSaveSearch = (ids) => {
  return async () => {
    try {
      return await SearchApi.inactiveSaveSearch(ids);
    } catch (error) {
      throw error;
    }
  };
 };

 export const getSearchCriteria = (id) => {
  return async () => {
    try {
      return await SearchApi.getSearchCriteria(id);
    } catch (error) {
      throw error;
    }
  };
 };
 export const saveAllAbstractsCriteria = (payload) => {
  return async () => {
    try {
      return await SearchApi.saveAllAbstractsCriteria(payload);
    } catch (error) {
      throw error;
    }
  };
 };

 export const getAllAbstractsCriteria = (id) => {
  return async () => {
    try {
      return await SearchApi.getAllAbstractsCriteria(id);
    } catch (error) {
      throw error;
    }
  };
 };

 export const deleteAllAbstractsCriteria = (id) => {
  return async () => {
    try {
      return await SearchApi.deleteAllAbstractsCriteria(id);
    } catch (error) {
      throw error;
    }
  };
 };

 export const checkSavedSearchtitleDuplicate = (title) => {
  return async () => {
    try {
      return await SearchApi.checkSavedSearchtitleDuplicate(title);
    } catch (error) {
      throw error;
    }
  };
 };
